module.exports = fox._r("images/join/radio.png", __webpack_public_path__ + "images/join/radio.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/join/radio.png
// module id = 1069
// module chunks = 4